import type { TravelPageDocument } from '@aller/types';
import type { estypes } from '@elastic/elasticsearch';

export interface PaginationOptions {
    sort?: estypes.Sort;
    page?: number;
    pageSize?: number;
}

export interface FacetOptions extends PaginationOptions {
    termFilters?: Record<string, string | string[]>;
    boolFilters?: Record<string, boolean>;
}

export interface SearchResult {
    hits: TravelDocumentWithBadge[];
    total: number | estypes.SearchTotalHits | undefined;
    page: number;
    pageSize: number;
}

export interface FacetResult extends SearchResult {
    facets: Record<string, Array<{ value: string; count: number }>>;
}

export interface TravelSearchResponse {
    hits: TravelPageDocument[];
    aggregations?: Record<string, estypes.AggregationsAggregate>;
    total: number | estypes.SearchTotalHits | undefined;
}

export enum BadgeType {
    Editorial,
    FewSeatsLeft,
    HasOffer,
    NewTrip,
    NewDeparture,
}

export interface TravelDocumentWithBadge extends TravelPageDocument {
    badge: BadgeType | null;
}
